import Api from './Api'

export default {
    getAtivas() {
        return Api().get('notificacao-geral/ativas');
    }
}